module.exports = __webpack_public_path__ + "img/thumb-003-03.da547c82.png";